// extracted by mini-css-extract-plugin
module.exports = {"burger":"classes_burger__3XPZl"};